import { Link } from "react-router-dom";
import Logo from "@/components/common/Logo";
import GradientBg from "@/components/common/GradientBg";
import { BRAND } from "@/branding.config";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen relative flex flex-col bg-background">
      <GradientBg variant="soft" />
      <header className="relative z-10 flex items-center justify-between px-6 h-16 border-b border-white/[0.06]">
        <Logo />
        <Link to="/" className="text-sm text-muted-foreground hover:text-foreground">← Back to {BRAND.short_name.toLowerCase()}.com</Link>
      </header>
      <main className="relative z-10 flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md">
          <div className="glass-strong p-8 md:p-10">
            <h1 className="text-3xl md:text-4xl font-black tracking-tight">{title}</h1>
            {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
            <div className="mt-8">{children}</div>
          </div>
          {footer && <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>}
        </div>
      </main>
    </div>
  );
}
